module.exports = __webpack_public_path__ + "77d22865680055181e8ab7e3f91bb9e1.fbx";